import {pluralize, React, observer, _} from '@api'
import {Tooltip} from '@material-ui/core'
import {IRollupResults, useBillOfMaterialsSpecRowStore} from './'
import * as css from './BOMRollups.css'

import { Tooltip2 } from '@api'


export const BOMRollups = observer<{ rollupResults: IRollupResults, includeSpecQuantity?: boolean }>(({rollupResults, includeSpecQuantity}) => {
  const store = useBillOfMaterialsSpecRowStore(),
    {strings} = store

  return (
    <div className={css.rollups}>
      {includeSpecQuantity && !_.isEmpty(rollupResults) &&
       <div className={css.rollup}>
        <label>Quantity Per Unit</label>
        <span className={css.value}>{_.first(rollupResults).quantity.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2})}</span>
      </div>}

      {rollupResults?.map(({def: {label, prefix, precision}, result, missingFieldValues, fieldValues, quantity}, i) => {
        //console.log({result, label, data, missingFieldValues, fieldValues, quantity})
        return (
          <Tooltip2
            key={i}
            content={_.isEmpty(missingFieldValues)
                   ? ''
                   : `The following required ${pluralize('value', missingFieldValues.length)} ${pluralize('is', missingFieldValues.length)} missing:\n ${missingFieldValues.map(f => store?.labelFor(f) ?? f).join(', ')}`}>
            <div className={css.rollup}>
              <label>{label}</label>
              <span className={css.value}>
              {(result === null) // Did we not find some of the fields?
               ? <span>{strings.emptyLabel}</span>
               : `${prefix ?? ''}${result.toLocaleString('en-US', {minimumFractionDigits: precision ?? 0, maximumFractionDigits: precision ?? 0})}`}
            </span>
            </div>
          </Tooltip2>
        )
      })}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/BillOfMaterials/BOMRollups.tsx